// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"_2VG8Xp","tcoButtonDisabled":"uFZpv2"};